import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function KrivicnoPravo() {
  return (
    <>
      <Navbar />
      <Bredcom
        title="Početna"
        subtitle="Krivično pravo - opšti i posebni dio"
      />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">
                Krivično pravo - opšti i posebni dio
              </h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Krivično pravo - opšti i
                posebni d
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Krivično pravo- opšti i posebni dio je razvijanje
                naučnih saznanja, sposobnosti i akademskih veština u procesu
                istraživanja u oblasti krivičnog prava. Opšti dio uvodi studente
                u suštinu pojmova i načela krivičnog prava, dok posebni dio
                proširuje stečena znanja kroz upoznavanje sa sudskom praksom.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Polaganjem ovog predmeta studenti će biti osposobljeni da:
                razumiju osnovne institute krivičnog prava, objasne sistem
                krivičnih sankcija, razlikuju krivičnu odgovornost fizičkih i
                pravnih lica, usklade crnogorsko krivično pravo sa modernim
                trendovima, te primijene stečena znanja u praksi.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava obuhvata pojmove, principe, istorijski razvoj
                krivičnog prava, elemente krivičnog djela, oblike izvršenja,
                saučesništvo, vrste kazni, mjere upozorenja i bezbednosti,
                amnestiju, pomilovanje, zastarjelost i maloljetničke krivične
                sankcije. Posebni dio uključuje krivična djela protiv različitih
                pravnih dobara i sistema.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: predavanja i vežbe,
                samostalni rad (seminarski rad i interaktivna nastava).
              </p>
              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>4P + 3V</td>
                    <td>
                      Pojam, predmet, naziv, izvori, osnovni principi,
                      istorijski razvoj krivičnog prava i nauke krivičnog prava;
                      Pojam i elementi krivičnog djela: Radnje krivičnog djela,
                      predviđenost zakonom, protivpravnost i krivica
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>4P + 3V</td>
                    <td>
                      Objekt i subjekt krivičnog djela; Pojam, elementi i osnovi
                      isključenja krivice; Stadijumi u izvršenju krivičnog djela
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>4P + 3V</td>
                    <td>
                      Oblici izvršenja krivičnog djela; Dioba i sticaj krivičnih
                      djela; Pojam, karakteristike i oblici saučesništva
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>4P + 3V</td>
                    <td>
                      Pojam, karakteristike, istorijski razvoj, svrha i vrste
                      krivičnih sankcija; Pojam i vrste kazni; Pojam, elementi,
                      vrste i karakteristike te pravila za odmjeravanje kazne
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>4P + 3V</td>
                    <td>
                      Mjere upozorenja, mjere bezbednosti, posebne
                      krivičnopravne mjere; Rehabilitacija i kaznena evidencija;
                      Praktična nastava: Analiza sudske prakse, debata
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>4P + 3V</td>
                    <td>
                      Amnestija, pomilovanje i zastarjelost; Pojam,
                      karakteristike i vrste maloljetničkih krivičnih sankcija
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>4P + 3V</td>
                    <td>
                      Krivična djela protiv života i tela, krivična djela protiv
                      sloboda i prava čovjeka i građanina, krivična djela protiv
                      izbornih prava
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>4P + 3V</td>
                    <td>
                      Krivična djela protiv časti i ugleda, krivična djela
                      protiv polne slobode, krivična djela protiv braka i
                      porodice, krivična djela protiv prava iz rada, krivična
                      djela protiv intelektualne svojine
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>4P + 3V</td>
                    <td>
                      Krivična djela protiv imovine, krivična djela protiv
                      platnog prometa i privrednog poslovanja, krivična djela
                      protiv zdravlja ljudi, krivična djela protiv životne
                      sredine
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>4P + 3V</td>
                    <td>
                      Krivična djela protiv opšte sigurnosti ljudi i imovine,
                      krivična djela protiv bezbednosti javnog saobraćaja,
                      krivična djela protiv bezbjednosti računarskih podataka;
                      Praktična nastava: Posjeta državnim institucijama, studija
                      slučaja
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>4P + 3V</td>
                    <td>
                      Krivična djela protiv ustavnog uređenja i bezbjednosti
                      Republike Crne Gore, krivična djela protiv državnih
                      organa, krivična djela protiv pravosuđa
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>4P + 3V</td>
                    <td>
                      Krivična djela protiv javnog reda i mira, krivična djela
                      protiv pravnog saobraćaja, krivična djela protiv službene
                      dužnosti
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>4P + 3V</td>
                    <td>
                      Krivična djela protiv čovječnosti i drugih dobara
                      zaštićenih međunarodnim pravom, krivična djela protiv
                      vojske Crne Gore; Praktična nastava: Posjeta državnim
                      organima, rješavanje praktičnih zadataka
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 7 č / 5.15h</td>
                            <td>Ukupno: 140 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 4 č / 3h</td>
                            <td>Nastava + završni ispit: 100 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 3 č / 2.15h</td>
                            <td>Priprema i ovjera semestra: 15 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 25 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default KrivicnoPravo;
